export default __webpack_public_path__ + "static/media/download.f619173c.svg";